export default __webpack_public_path__ + "static/media/visa.7ff8c8ed.svg";